module.exports = __webpack_public_path__ + "assets/media/lunch.9aa8a8cc.mp3";